var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoreVertBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3456 6.66659C12.2998 6.66659 13.0804 5.91659 13.0804 4.99992C13.0804 4.08325 12.2998 3.33325 11.3456 3.33325C10.3915 3.33325 9.61084 4.08325 9.61084 4.99992C9.61084 5.91659 10.3915 6.66659 11.3456 6.66659ZM11.3456 8.33325C10.3915 8.33325 9.61084 9.08325 9.61084 9.99992C9.61084 10.9166 10.3915 11.6666 11.3456 11.6666C12.2998 11.6666 13.0804 10.9166 13.0804 9.99992C13.0804 9.08325 12.2998 8.33325 11.3456 8.33325ZM11.3456 13.3333C10.3915 13.3333 9.61084 14.0833 9.61084 14.9999C9.61084 15.9166 10.3915 16.6666 11.3456 16.6666C12.2998 16.6666 13.0804 15.9166 13.0804 14.9999C13.0804 14.0833 12.2998 13.3333 11.3456 13.3333Z",
    fill: "#0E88FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreVertBlue);
export default __webpack_public_path__ + "static/media/more-vert-blue.e8529fae372e88a30a03d23a2b2658a5.svg";
export { ForwardRef as ReactComponent };